import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { handleSuccessToast } from 'src/components/molecules';
import { ChangePasswordNew } from 'src/components/organisms/ChangePasswordNew/ChangePasswordNew';
import LoginContainer from '../LoginContainer';

interface Props {
  token: string;
}

export const CreateSignUpPassword = (props: Props) => {
  const [redirect, setRedirect] = React.useState(false);

  const onPasswordChangeSuccess = () => {
    handleSuccessToast({
      toastMessage: 'Password created',
      toastDescription: 'Your password has been successfully created.',
    });
    setRedirect(true);
  };

  if (redirect) {
    return <Redirect to={'/login'} />;
  }

  return (
    <LoginContainer
      data-testid="reset"
      header="Sign up"
      description="Create a strong password to keep your account secure. Start typing to see guidelines below."
      includeForm={false}
    >
      <ChangePasswordNew
        data-testid="sign-up"
        buttonText={'Sign up'}
        onPasswordChangeSuccess={onPasswordChangeSuccess}
        updateWithToken={true}
        token={props.token}
      />
    </LoginContainer>
  );
};

export default CreateSignUpPassword;
